import { useCallback } from "react";
import { useApiQuery, toList } from "../../useApiQuery";

export interface Offer {
    NUMOPERATION?: string;
    OPERATIONNAME?: string;
    OFFERDESCRIPTION?: string;
    SENTDATE?: string;
    CANAL?: string;
    STARTDATE?: string;
    ENDDATE?: string;
    ISUSED?: string | null;
    OFFER_NUMBER_RECIPIENT_ID?: string;
    TRDATE?: string;
    [key: string]: unknown;
}

const useGetOffers = () => {
    const { data: offers, isLoading, error, fetch } = useApiQuery<Offer[]>("/getOffersPerson", {
        initialData: [],
        transform: toList<Offer>,
    });

    const getOffers = useCallback(
        (personId: string | number, limit = 10) => fetch({ person_id: personId, limit }),
        [fetch]
    );

    return { offers, isLoading, error, getOffers };
};

export default useGetOffers;
